import { useState } from 'react';

export default function useCredentials() {
  const getCredentials = () => {
    const credentialsString = localStorage.getItem("credentials");
    return credentialsString && JSON.parse(credentialsString);
  }

  const [credentials, setСredentials] = useState(getCredentials());

  const saveСredentials = credentials => {
    if (credentials) 
      localStorage.setItem("credentials", JSON.stringify(credentials));
    else 
      localStorage.removeItem("credentials");
  }

  return {
    setCredentials: credentials => {
      saveСredentials(credentials);
      setСredentials(credentials);
    },
    saveСredentials,
    credentials
  }
}